import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home.vue'
import More from './views/more.vue'
import FriendWen from './views/friendWen/index.vue'
import GreenAndDownload from './views/greenAndDownload/index.vue'
import Information from './views/information/index.vue'
import MagicWeapon from './views/magicWeapon/index.vue'
import PlowCloudMentor from './views/plowCloudMentor/index.vue'
//详情
import ArticleDetail from './views/detail/articleDetail.vue'
import MusicDetail from './views/detail/musicDetail.vue'
import ExperienceDetail from './views/detail/experienceDetail.vue'


Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [{
            path: "/",
			component: Home,
        },
        {
            path: "/more",
            component: More
        },
        {
            path: "/plowCloudMentor",
            component: PlowCloudMentor
        },
        {
            path: "/friendWen",
            component: FriendWen
        }, {
            path: "/greenAndDownload",
            component: GreenAndDownload
        }, {
            path: "/information",
            component: Information
        }, {
            path: "/magicWeapon",
            component: MagicWeapon
        },
        {
            path: "/articleDetail",
            component: ArticleDetail
        }, {
            path: "/musicDetail",
            component: MusicDetail
        }, {
            path: "/experienceDetail",
            component: ExperienceDetail
        }
    ]
})